import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './LoginPage/LoginPage';
import Home from './Home/Home';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Redirecciona / a /login */}
        <Route path="/" element={<Navigate to="/login" />} />

        {/* Página de login */}
        <Route path="/login" element={<LoginPage />} />

        {/* Página principal después del login */}
        <Route path="/home" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default App;
